// src/core/adapters/LondonVisualiserBuses.js
//
// Bus transforms for the route visualiser.
// Pure functions. No React, no styles, no I/O.

export const splitBusesByDirection = (buses) => {
  const outbound = [];
  const inbound = [];
  (buses || []).forEach(b => {
    const dir = b.direction?.toLowerCase();
    if (dir === 'outbound') outbound.push(b);
    else if (dir === 'inbound') inbound.push(b);
  });
  return { outbound, inbound };
};

export const averageHeadway = (buses) => {
  const valid = (buses || []).filter(b => b.headway != null && !isNaN(b.headway));
  if (valid.length === 0) return null;
  return valid.reduce((sum, b) => sum + b.headway, 0) / valid.length;
};

// Map of naptan_id → expected_arrival (ISO) for the selected vehicle on the given lane.
export const buildVehicleExpectedTimes = (expectedArrivals, vehicleId, direction) => {
  if (!vehicleId) return null;
  const map = new Map();
  (expectedArrivals || [])
    .filter(e => String(e.vehicle_id) === String(vehicleId) && e.direction === direction)
    .forEach(p => {
      if (p.naptan_id && p.expected_arrival) {
        map.set(p.naptan_id, p.expected_arrival);
      }
    });
  return map;
};

// Selected bus moves to end so it renders above others.
export const sortBusesWithSelectedLast = (buses, selectedId) => {
  return [...(buses || [])].sort((a, b) => {
    if (a.vehicle_id === selectedId) return 1;
    if (b.vehicle_id === selectedId) return -1;
    return 0;
  });
};

// Groups buses by their matched stop index. Within a group, sorts by trip_no_lbsl.
export const groupBusesByStop = (sortedBuses, stopIndexMap) => {
  const groups = new Map();
  sortedBuses.forEach(bus => {
    const naptan = String(bus.naptan_id).trim().toUpperCase();
    const matchedIndex = stopIndexMap.get(naptan);
    if (matchedIndex === undefined) return;
    if (!groups.has(matchedIndex)) groups.set(matchedIndex, []);
    groups.get(matchedIndex).push(bus);
  });
  for (const [, group] of groups) {
    group.sort((a, b) =>
      String(a.trip_no_lbsl || '').localeCompare(String(b.trip_no_lbsl || ''))
    );
  }
  return groups;
};

export const buildBusRankMap = (busGroups) => {
  const map = new Map();
  for (const [, group] of busGroups) {
    group.forEach((bus, idx) => {
      map.set(bus.vehicle_id, idx);
    });
  }
  return map;
};